// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"actionsBeneficiaryModal_buttonsContainer__Hw7Tz"};